export const ACCESS_TOKEN = "accessToken"
export const WEAVR_TOKEN = "weavrAccessToken"
export const COMPANY_ID = "companyId"

const LocalStorageService = {
    isAuthorized: () => LocalStorageService.get(ACCESS_TOKEN) !== null,
    getAuthenticationHeader: () => ({
        Authorization: "Bearer " + LocalStorageService.get(ACCESS_TOKEN),
        "x-weavr-token": LocalStorageService.get(WEAVR_TOKEN),
    }),
    setCompanyId: (value: string) => localStorage.setItem(COMPANY_ID, value),
    getCompanyId: () => localStorage.getItem(COMPANY_ID),
    setWeavrToken: (value: string) => localStorage.setItem(WEAVR_TOKEN, value),
    setAccessToken: (value: string) => localStorage.setItem(ACCESS_TOKEN, value),
    unsetWeavrToken: () => localStorage.removeItem(WEAVR_TOKEN),
    unsetAccessToken: () => localStorage.removeItem(ACCESS_TOKEN),
    get: (key: string) => localStorage.getItem(key),
    clear: () => localStorage.clear(),
}

export default LocalStorageService
